
  import { Component, Vue } from "vue-property-decorator";
  import VueCookies from "vue-cookies";
  import { mapGetters } from "vuex";
  import { IUserModel, IBlockModel } from '@/models/account.model';
  import userService from '@/services/user.service';
  import errorsService from '@/services/errors.service';
  import unblockService from "@/services/unblock.service";

  Vue.use(VueCookies);

  interface IBlockLoadingModel extends IBlockModel {
    isLoading?: boolean;
  }

  @Component({
    computed: {
      ...mapGetters([
        "user",
      ]),
    },
  })
  export default class Blocking extends Vue {
    data() {
      return {
        userBlocks: [] as Array<IBlockModel>,
        unwatch: null
      }
    };

    created() {
      this.$data.unwatch = this.$store.watch(() => this.$store.getters.user, user => {
        this.setBlockList(user);
      });

      if (this.$store.getters.user.Id != null) {
        this.setBlockList(this.$store.getters.user);
      }
    }

    setBlockList(user: IUserModel) {
      this.$data.userBlocks = user.Blocks.map((block: IBlockModel) => {
        return { ...block, isLoading: false }
      });
    }

    unblock(block: IBlockLoadingModel) {
      block.isLoading = true;

      unblockService.unblock(this, block.Id).then(async () => {
        userService.updateUser(this, false, true);
        block.isLoading = false;
      })
        .catch(error => {
          errorsService.handleErrors(this, error);
          block.isLoading = false;
        });
    }

    destroyed() {
      this.$data.unwatch();
    }
  }

